import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	height: 100%;
	padding: 1% 1% 0 1%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	margin: 10px 2px 10px 10px;
	flex-direction: column;
	align-items: flex-end;
`;

export const SavingDiv = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	justify-content: 'center';
	align-items: 'center';
`;

export const TableWrapper = styled.div`
	width: 100%;
	.ag-theme-balham {
		.ag-header-cell {
			text-align: center;
		}
		.ag-header-row {
			.ag-header-cell {
				.ag-cell-label-container {
					justify-content: center;

					.ag-header-cell-label {
						flex: unset;
					}
				}
			}
		}
		.ag-row {
			.ag-cell {
				text-align: center;
			}
		}
	}
`;
